module.exports = __webpack_public_path__ + "static/media/food11.91776194.webp";